import { render, staticRenderFns } from "./AudienceSegmentHome.vue?vue&type=template&id=0a18d8a8&"
import script from "./AudienceSegmentHome.vue?vue&type=script&lang=ts&"
export * from "./AudienceSegmentHome.vue?vue&type=script&lang=ts&"
import style0 from "./AudienceSegmentHome.vue?vue&type=style&index=0&id=0a18d8a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports